import React, { FC } from 'react'
import s from './Quantity.module.css'
import { LegacyCross, Plus, Minus } from '@components/icons'
import cn from 'clsx'
export interface QuantityProps {
  value: number
  increase: () => any
  decrease: () => any
  handleRemove: React.MouseEventHandler<HTMLButtonElement>
  giftWrappingHandleRemove: React.MouseEventHandler<HTMLButtonElement>
  handleChange: React.ChangeEventHandler<HTMLInputElement>
  isGiftWrapping: boolean
  isDiscountedProduct: boolean
  isMaximumQuantity?: boolean
}

const Quantity: FC<QuantityProps> = ({
  value,
  increase,
  decrease,
  handleChange,
  handleRemove,
  giftWrappingHandleRemove,
  isGiftWrapping,
  isDiscountedProduct,
  isMaximumQuantity
}) => {
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row ml-[1px] mb-[5px]">
        {value > 1 && (
          <>
            {isDiscountedProduct && (
              <>
                <button
                  type="button"
                  onClick={decrease}
                  className={s.quantityBtn}
                  disabled={value <= 1}
                >
                  <Minus width={13} />
                </button>
                <span className={s.quantityNumber}>{value}</span>

                <button
                  type="button"
                  onClick={increase}
                  className={cn(s.quantityBtn, {[s.isMaximumQuantity]: isMaximumQuantity})}
                  disabled={value < 1}
                >
                  <Plus width={13} />
                </button>
              </>
            )}
          </>
        )}

        {isDiscountedProduct ? (
          <button
            type="button"
            onClick={decrease}
            className={s.discount}
            disabled={value <= 1}
          >
            <Minus width={13} />
          </button>
        ) : (
          <>
            {!isGiftWrapping && (
              <button
                type="button"
                onClick={decrease}
                className={s.quantityBtn}
                disabled={value <= 1}
              >
                <Minus width={13} />
              </button>
            )}
            {!isGiftWrapping && (
              <span className={s.quantityNumber}>{value}</span>
            )}

            {/* <label className=" ml-2">
<input
  className={s.quantityInput}
  onChange={(e) =>
    Number(e.target.value) < max + 1 ? handleChange(e) : () => {}
  }
  value={value}
  type="number"
  max={max}
  min="0"
  readOnly
/>
</label> */}
            {!isGiftWrapping && (
              <button
                type="button"
                onClick={increase}
                className={cn(s.quantityBtn, {[s.isMaximumQuantity]: isMaximumQuantity})}
                disabled={value < 1}
              >
                <Plus width={13} />
              </button>
            )}
          </>
        )}
        <></>
      </div>
      {/* <button className={s.remoteBtn} onClick={handleRemove}>
        Remove
      </button> */}
      {isGiftWrapping ? (
        <button className={s.remoteBtn} onClick={giftWrappingHandleRemove}>
          Remove
        </button>
      ) : (
        <button className={s.remoteBtn} onClick={handleRemove}>
          Remove
        </button>
      )}
    </div>
  )
}

export default Quantity
